import { Line } from 'app/hooks/useRulerTools';
import { t } from 'i18next';

export function toRadians(degrees: number) {
  return (degrees * Math.PI) / 180;
}
/**
 * Calculates the distance between two points on the Earth's surface using the Haversine formula
 *
 *
 * @param {Line} line - The line object containing source and target positions
 * @returns {number} - Distance in nautical miles between the two points
 */
export function getDistance(line: Line) {
  const lat1 = line.sourcePosition[1];
  const lat2 = line.targetPosition[1];

  const lon1 = line.sourcePosition[0];
  const lon2 = line.targetPosition[0];

  const R = 3443.92; // радиус Земли в морских милях

  const lat1Rad = toRadians(lat1);
  const lat2Rad = toRadians(lat2);
  const deltaLat = toRadians(lat2 - lat1);
  const deltaLon = toRadians(lon2 - lon1);

  const a =
    Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.sin(deltaLon / 2) * Math.sin(deltaLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const distance = R * c;
  return distance;
}

export function getDistanceText(distance?: number) {
  if (!distance || distance <= 0 || Number.isNaN(distance)) return '';
  return `${distance.toFixed(1)}` + `${t('NM')}`;
}
